import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=f48933d4&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f48933d4')) {
      api.createRecord('f48933d4', component.options)
    } else {
      api.reload('f48933d4', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=f48933d4&", function () {
      api.rerender('f48933d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wI6B5znPJXCu/JS/pricelisthelp.vue"
export default component.exports